<template>
  <Loader :loading="isTotalsLoading" :text="$t('Loading Totals...')">
    <div class="total-items" v-if="showTotals">
      <SfProperty
        v-for="total in totalsList"
        :key="total.name"
        :name="total.name"
        class="sf-property--full-width"
        :class="total.class"
      >
        <template #value>
          <SfPrice :regular="total.regular" />
        </template>
      </SfProperty>
    </div>
  </Loader>
</template>
<script>
import { SfProperty, SfPrice } from '@storefront-ui/vue';
import { Loader, config } from '@/modules/core';
import cart from '../mixins/cart';

export default {
  name: 'Totals',
  mixins: [cart, config],
  components: {
    SfProperty,
    SfPrice,
    Loader,
  },
  props: {
    customTotals: {
      type: Object,
    },
  },
  computed: {
    calculatedTotals() {
      return this.customTotals || this.totals;
    },
    totalsList() {
      return [
        {
          name: this.$t('Sub Total'),
          regular: this.currencyFormatter().format(this.calculatedTotals.SubTotal),
        },
        ...(() => (this.calculatedTotals.SubTotalDiscount
          ? [
            {
              name: this.$t('Sub Total Discount'),
              regular: this.currencyFormatter().format(this.calculatedTotals.SubTotalDiscount),
            },
          ]
          : []))(),
        ...(() => (this.calculatedTotals.Shipping
          ? [
            {
              name: this.$t('Shipping'),
              regular: this.currencyFormatter().format(this.calculatedTotals.Shipping),
            },
          ]
          : []))(),
        ...(() => (this.calculatedTotals.PaymentMethodAdditionalFee
          ? [
            {
              name: this.$t('Payment Method Fee'),
              regular: this.currencyFormatter().format(
                this.calculatedTotals.PaymentMethodAdditionalFee,
              ),
            },
          ]
          : []))(),
        ...(() => (this.calculatedTotals.DisplayTax
          ? [
            {
              name: this.$t('Tax'),
              regular: this.currencyFormatter().format(this.calculatedTotals.Tax),
            },
          ]
          : []))(),
        ...(() => (this.calculatedTotals.DisplayTaxRates
          ? this.calculatedTotals.TaxRates.map((rate) => ({
            name: this.$t('Tax Rate'),
            regular: `${rate.Rate}% ${this.currencyFormatter().format(rate.Value)}`,
          }))
          : []))(),
        ...(() => (this.calculatedTotals.OrderTotalDiscount
          ? [
            {
              name: this.$t('Order Total Discount'),
              regular: this.currencyFormatter().format(
                this.calculatedTotals.OrderTotalDiscount,
              ),
            },
          ]
          : []))(),
        {
          name: this.$t('Order Total'),
          regular: this.calculatedTotals.OrderTotal
            ? this.currencyFormatter().format(this.calculatedTotals.OrderTotal)
            : this.currencyFormatter().format(this.calculatedTotals.SubTotal),
          class: 'sf-property--large',
        },
      ];
    },
  },
};
</script>
<style lang="scss" scoped>
@import '~@storefront-ui/shared/styles/_helpers';
@import 'src/scss/_breakpoint.scss';

.total-items .sf-property {
  margin-bottom: 5px;
}
</style>
